import {
  Component,
  EventEmitter,
  Input,
  Output,
  SimpleChanges,
  OnChanges,
} from '@angular/core';
import { NgClass } from '@angular/common';

@Component({
  selector: 'app-tab-selector',
  templateUrl: './tab-selector.component.html',
  styleUrls: ['./tab-selector.component.css'],
  imports: [NgClass],
})
export class TabSelectorComponent implements OnChanges {
  @Input() tabValues: {
    name: string;
    code?: string;
    iconSrc: string;
    selectedIconSrc: string;
  }[] = [];
  @Input() selectDisabled = false;
  @Output() selectedTab = new EventEmitter<string>();
  selectedTabName = '';

  ngOnChanges(changes: SimpleChanges) {
    if (changes.tabValues && changes.tabValues.currentValue.length > 0) {
      if (this.selectedTabName === '')
        this.selectedTabName = this.tabValues[0].name;
    }
  }

  onTabClick(tabName: string) {
    if (this.selectDisabled) return;
    this.selectedTabName = tabName;
    this.selectedTab.emit(tabName);
  }
}
